<template>
        <v-dialog
            v-model="dialog"
            max-width="450"
            :persistent="persistent">
            <v-card
                class="modal-warning d-flex flex-column"
                :style="{ 'min-height': height }">
                <div class="modal-close-btn">
                    <slot name="modal-close-btn">
                        <v-icon size="18"
                            class="close-icon"
                            @click="validateOnClose ? $emit('on-close') : closeModal()">
                            mdi-window-close
                        </v-icon>
                    </slot>
                </div>
                <div class="modal-position icon-position" v-if="showModalIcon">
                    <slot name="modal-icon">
                        <img src="@/assets/icon/delete-warning.webp" />
                    </slot>
                </div>
                <v-card-title class="modal-position text-header modal font-x-large">
                    <slot name="modal-header">
                        {{ form.header }}
                    </slot>
                </v-card-title>
                <v-card-text class="px-2 d-flex flex-column flex-grow-1">
                    <slot name="modal-content">
                        <div v-if="form.content" class="d-flex flex-column align-center text-content font-large">
                            {{ form.content }}
                        </div>
                        <div class="d-flex flex-column align-center text-content font-large"
                            v-for="item, index in form.contents" :key="index">
                            {{ item }}
                        </div>
                    </slot>
                </v-card-text>
                <v-card-actions class="modal-position pb-8 mx-3 mx-sm-7" v-if="!noBottomAction">
                    <slot name="modal-footer">
                        <v-row>
                            <v-col cols="12" sm="6" class="px-1 py-1">
                                <v-btn
                                    :class="btnCancelClass"
                                    block
                                    width="180px"
                                    @click="validateOnCancel ? $emit('on-cancel') : closeModal()">
                                    {{ btnCancelText }}
                                </v-btn>
                            </v-col>
                            <v-col cols="12" sm="6" class="px-1 py-1">
                                <v-btn
                                    :class="bthConfirmClass"
                                    block
                                    width="180px"
                                    :disabled="btnConfirmDisabled"
                                    @click="$emit('on-confirm')">
                                    {{ btnConfirmText }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </slot>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
export default {
    name: 'WarningModal',

    props: {
        form: {
            type: Object,
            default: () => ({
                header: '',
                content: '',
                contents: []
            })
        },

        routeName: {
            type: String,
            default: null
        },

        height: {
            type: String,
            default: '130px'
        },

        // Btn classes (primary, secondary, error)
        btnCancelClass: {
            type: String,
            default: 'secondary'
        },

        bthConfirmClass: {
            type: String,
            default: 'error'
        },

        btnConfirmText: {
            type: String,
            default: ''
        },

        btnCancelText: {
            type: String,
            default: ''
        },

        btnConfirmDisabled: {
            type: Boolean,
            default: false
        },

        persistent: {
            type: Boolean,
            default: false
        },

        validateOnClose: {
            type: Boolean,
            default: false
        },

        validateOnCancel: {
            type: Boolean,
            default: false
        },

        showModalIcon: {
            type: Boolean,
            default: true
        },

        noBottomAction: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            dialog: false
        }
    },

    methods: {
        openModal () {
            this.dialog = true
        },
        closeModal () {
            this.dialog = false
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-close-btn {
    display: flex;
    justify-content: flex-end;
    padding-right: 1rem;
    padding-top: 1rem;

    margin-right: 5px;
}
.modal-position {
    display: flex;
    justify-content: center;
}

::v-deep .v-dialog > .v-card > .v-card__title {
    padding-top: 5px;
}

::v-deep .v-dialog {
    margin: 16px;
}

.modal-warning {
    border-radius: 10px;
}

.grow {
    display: flex;
    flex-grow: 1;
}

.icon-position {
    padding-top: 5px;
}

.close-icon {
    color: $onyx;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
}
</style>
